import { Ship, Truck, Plane } from 'lucide-react';

export const PER_PAGE = 10;

export const STATUS_KEYS = {
  loaded:     { variant: 'preparing', key: 'status_loaded',     group: 'transit'   },
  departed:   { variant: 'transit',   key: 'status_departed',   group: 'transit'   },
  in_transit: { variant: 'transit',   key: 'status_in_transit', group: 'transit'   },
  arrived:    { variant: 'transit',   key: 'status_arrived',    group: 'transit'   },
  delivered:  { variant: 'delivered', key: 'status_delivered',  group: 'delivered' },
  incident:   { variant: 'incident',  key: 'status_incident',   group: 'incident'  },
};

export const MODE_KEY = { reefer: 'reefer', road: 'route', air: 'air' };

export const STATUS_PROGRESS = {
  loaded:     20,
  departed:   35,
  in_transit: 65,
  arrived:    87,
  delivered:  100,
  incident:   50,
};

export const STEP_CONFIG = {
  loaded:     { doneCount: 2, activeIdx: null },
  departed:   { doneCount: 3, activeIdx: 3    },
  in_transit: { doneCount: 3, activeIdx: 3    },
  arrived:    { doneCount: 4, activeIdx: 4    },
  delivered:  { doneCount: 6, activeIdx: null },
  incident:   { doneCount: 3, activeIdx: 3    },
};

export const TRANSPORT = {
  reefer: { Icon: Ship,  bg: 'bg-sky-50',    text: 'text-sky-800'     },
  route:  { Icon: Truck, bg: 'bg-orange-50', text: 'text-orange-700'  },
  air:    { Icon: Plane, bg: 'bg-sky-50',    text: 'text-sky-700'     },
};

export const ALL_STATUSES = ['loaded', 'departed', 'in_transit', 'arrived', 'delivered', 'incident'];

export const DOC_TYPE_COLORS = {
  PDF:  { bg: 'bg-rose-50',    text: 'text-rose-600'    },
  JPG:  { bg: 'bg-sky-50',     text: 'text-sky-600'     },
  JPEG: { bg: 'bg-sky-50',     text: 'text-sky-600'     },
  PNG:  { bg: 'bg-sky-50',     text: 'text-sky-600'     },
  XLS:  { bg: 'bg-emerald-50', text: 'text-emerald-600' },
  XLSX: { bg: 'bg-emerald-50', text: 'text-emerald-600' },
  DOC:  { bg: 'bg-blue-50',    text: 'text-blue-600'    },
  DOCX: { bg: 'bg-blue-50',    text: 'text-blue-600'    },
};

export function fmtDate(d, locale) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString(locale === 'en' ? 'en-GB' : 'fr-FR', {
    day: '2-digit', month: 'short', year: 'numeric',
  });
}

export function fmtFileSize(bytes) {
  if (bytes == null) return null;
  if (bytes >= 1_000_000) return `${(bytes / 1_000_000).toFixed(1)} Mo`;
  if (bytes >= 1_000)     return `${Math.round(bytes / 1_000)} Ko`;
  return `${bytes} o`;
}
